import { useState } from 'react';

/**
 * SectionBanner — explicacion concreta de "para que sirve" cada pestana.
 *
 * Una sola frase central, lenguaje humano, cerrable (X). Si el usuario lo
 * cierra, no vuelve a aparecer (localStorage por id). Estilo consistente:
 * tarjeta con tokens de tema (claro/oscuro) y franja dorada.
 *
 * Uso: <SectionBanner id="assets" title="Tu dinero disponible" text="..." />
 */
export default function SectionBanner({ id, title, text }) {
  const LS_KEY = `fp_section_banner_${id}`;
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(LS_KEY) === '1'; } catch { return false; }
  });

  if (dismissed) return null;

  const dismiss = () => {
    try { localStorage.setItem(LS_KEY, '1'); } catch {}
    setDismissed(true);
  };

  return (
    <div
      className="relative rounded-[14px] px-5 py-3.5 mb-5 overflow-hidden"
      style={{ background: 'var(--fx-card)', border: '1px solid var(--fx-border)' }}
    >
      <div className="absolute left-0 top-0 bottom-0 w-1" style={{ background: 'linear-gradient(180deg,#C9A961,#E3C77E)' }} />
      <button
        onClick={dismiss}
        aria-label="Cerrar"
        type="button"
        className="absolute top-2.5 right-2.5 w-6 h-6 rounded-full flex items-center justify-center text-sm leading-none"
        style={{
          background: 'color-mix(in srgb, var(--fx-muted) 16%, transparent)',
          color: 'var(--fx-muted)',
        }}
      >
        ×
      </button>
      <div className="pl-2 pr-6">
        <p style={{ color: 'var(--fx-text)' }} className="text-sm font-semibold leading-tight">{title}</p>
        <p style={{ color: 'var(--fx-muted)' }} className="text-sm leading-snug mt-0.5">{text}</p>
      </div>
    </div>
  );
}
